import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const GlassAppBar = styled(AppBar)(({ theme }) => ({
  background: 'rgba(32, 45, 58, 0.75)',
  backdropFilter: 'blur(8px)',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
  color: '#ffffff',
}));

const NavButton = styled(Button)(({ theme }) => ({
  color: '#ffffff',
  marginLeft: theme.spacing(2),
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

export default function Navbar() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <GlassAppBar position="sticky" elevation={0}>
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: '#ffffff',
          }}
        >
          <img
            src="https://static.vecteezy.com/system/resources/previews/009/121/863/non_2x/neo-logo-neo-letter-neo-letter-logo-design-initials-neo-logo-linked-with-circle-and-uppercase-monogram-logo-neo-typography-for-technology-business-and-real-estate-brand-vector.jpg"
            alt="Neo Typer"
            style={{ width: 40, borderRadius: '50%', marginRight: 10 }}
          />
          <span style={{ fontSize: 20, fontWeight: 600 }}>
            Neo <b style={{ color: '#16f288' }}>Typer</b>
          </span>
        </Link>

        <div>
          <NavButton component={Link} to="/dashboard">Dashboard</NavButton>
          <NavButton
            href="https://www.mediafire.com/file/halzm8wxsqiyagp/Neo_Typer_Pro.exe/file"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download App
          </NavButton>

          {/* Admin button removed */}
          {!isAuthenticated && (
            <>
              <NavButton component={Link} to="/login">Login</NavButton>
              <NavButton component={Link} to="/signup">Signup</NavButton>
            </>
          )}
          {isAuthenticated && (
            <NavButton
              onClick={() => {
                logout();
                navigate('/login');
              }}
              variant="outlined"
              style={{
                borderColor: '#16f288',
                color: '#16f288',
              }}
            >
              Logout
            </NavButton>
          )}
        </div>
      </Toolbar>
    </GlassAppBar>
  );
}
